'use client';

import { ReactNode } from 'react';
import Analytics from './Analytics';
import CookieConsent from './CookieConsent';

interface AnalyticsProviderProps {
  children: ReactNode;
  showCookieBanner?: boolean;
}

/**
 * AnalyticsProvider combines the Analytics and CookieConsent components into a single,
 * reusable provider component that can be added to any layout in the application.
 * 
 * This ensures consistent analytics tracking and cookie consent behavior across
 * custom layouts.
 * 
 * @param children The child components to render
 * @param showCookieBanner Whether to show the cookie banner (default: true)
 */
export default function AnalyticsProvider({ 
  children, 
  showCookieBanner = true 
}: AnalyticsProviderProps) {
  return (
    <>
      {children}
      {showCookieBanner && <CookieConsent />}
      <Analytics />
    </>
  );
} 